// extracted by mini-css-extract-plugin
module.exports = {"root":"ybKrefVGFE2a7zppyx69n","icon":"_2WBmc7F-JB5N6Ikbef4eih","iconWithSize":"_38_Hgt1XMPPHBaOmo02Nbs"};